import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { useAwarenessMembers, colorForUserId } from '../../../lib/yjs';
import { getAvatarUrl } from '../../../utils/get-avatar-url';

import {
	selectIsBtnPopupNewsEnabled,
	selectIsBtnExportImageEnabled,
	selectIsControlsFocusMode,
	selectIsTopControlsHidden,
} from '../../../redux/diagram/diagram.selectors';

import {
	selectIsModalSupportEnabled,
	selectIsModalDiagramShareEnabled,
} from '../../../redux/main/main.selectors';
import { toggleModalDiagramShare, toggleSupport } from '../../../redux/main/main.actions';

import { selectAuthUser } from '../../../redux/auth/auth.selectors';

import { selectDiagramMembers } from '../../../redux/canvas/canvas.selectors';
import { fetchDiagramMembers } from '../../../redux/canvas/canvas.actions';

import * as Tooltip from '@radix-ui/react-tooltip';

const ROLES_MAP = {
	owner: 'Owner',
	admin: 'Admin',
	edit: 'Editor',
	comment: 'Commenter',
	view: 'Viewer',
};

import './ControlsTopRight.scss';

export const ControlsTopRight = ({ awareness }) => {
	const { diagramId } = useParams();  // отримаємо ID діаграми з URL

	const dispatch = useDispatch();

	const history = useHistory();

	const { t, i18n } = useTranslation();

	const handleClick = () => {
		setTimeout(() => {
			history.push(`/`);
		}, 100);
	};



	const isBtnPopupNewsEnabled = useSelector(selectIsBtnPopupNewsEnabled);
	const isBtnExportImageEnabled = useSelector(selectIsBtnExportImageEnabled);
	const isControlsFocusMode = useSelector(selectIsControlsFocusMode);
	const isTopControlsHidden = useSelector(selectIsTopControlsHidden);
	const topHidden = isControlsFocusMode && isTopControlsHidden;

	const isModalSupportEnabled = useSelector(selectIsModalSupportEnabled);
	const isModalDiagramShareEnabled = useSelector(selectIsModalDiagramShareEnabled);

	const currentUser = useSelector(selectAuthUser);
	const diagramMembers = useSelector(selectDiagramMembers);

	useEffect(() => {
		if (diagramId) dispatch(fetchDiagramMembers(diagramId));
	}, [diagramId, dispatch]);

	const roleByUserId = diagramMembers.reduce((acc, m) => {
		acc[m.user_id] = m.role;
		return acc;
	}, {});

	const remoteMembers = useAwarenessMembers(awareness);

	const allMembers = currentUser
		? [{ user: { id: currentUser.id, name: currentUser.name || currentUser.email || '', image: currentUser.image || null, color: colorForUserId(currentUser.id) } }, ...remoteMembers]
		: remoteMembers;

	// { user, anchorEl } | null
	const [openMember, setOpenMember] = useState(null);
	const openMemberRef = useRef(null);
	const memberMenuRef = useRef(null);

	const handleAvatarClick = (user, e) => {
		e.stopPropagation();
		if (openMemberRef.current?.user.id === user.id) {
			setOpenMember(null);
			openMemberRef.current = null;
		} else {
			const next = { user, anchorEl: e.currentTarget };
			setOpenMember(next);
			openMemberRef.current = next;
		}
	};

	useEffect(() => {
		const handleDocumentClick = () => {
			if (openMemberRef.current) {
				setOpenMember(null);
				openMemberRef.current = null;
			}
		};
		document.addEventListener('click', handleDocumentClick);
		return () => document.removeEventListener('click', handleDocumentClick);
	}, []);

	const getMemberMenu = (open) => {
		if (!open) return null;
		const { user, anchorEl } = open;
		const isCurrentUser = user.id === currentUser?.id;
		const roleKey = roleByUserId[user.id];
		const roleLabel = ROLES_MAP[roleKey] ?? 'Member';

		console.log('Members: ', roleLabel, roleKey, user, roleByUserId)
		const rect = anchorEl.getBoundingClientRect();
		// const top = rect.bottom + window.scrollY + 7;
		const top = 55;
		const rightOffset = document.documentElement.scrollWidth - (rect.right + window.scrollX) - 84;

		return (
			<div
				className="profile-group"
				ref={memberMenuRef}
				onClick={(e) => e.stopPropagation()}
				style={{ top: `${top}px`, right: `${rightOffset}px` }}
			>
				<div className="controls-group">
					<div className="control">
						<button
							className="control-button control-button-profile"
							type="button"
							aria-pressed="false"
						>
							<div className="button-profile">
								{user.image
									? <img className="button-profile-image-small" src={getAvatarUrl(user.image)} width="42px" height="42px" referrerPolicy="no-referrer" />
									: <span className="button-profile-text" style={{ background: user.color }}>{(user.name || '?')[0].toUpperCase()}</span>
								}
							</div>
							<div className="button-profile-text2">
								<div>{user.name}</div>
								<div className="button-profile-text2-subtext">{roleLabel}</div>
							</div>
						</button>
					</div>

					{isCurrentUser && (
						<div className="control control-view-profile">
							<button
								className="control-button button-view-profile"
								type="button"
								onClick={() => {
									window.open('/settings/profile/', '_blank');
									setOpenMember(null);
									openMemberRef.current = null;
								}}
							>
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
								Profile settings
							</button>
						</div>
					)}
				</div>
			</div>
		);
	};


	return (
		// <div className="controls_top_right" style={{ top: `${isBtnPopupNewsEnabled ? 66 : 9 }px`}}>
		<div className={`controls_top_right ${isBtnExportImageEnabled ? 'hide' : ''} ${topHidden ? 'focus-hidden' : ''}`} style={{ top: `${isBtnPopupNewsEnabled ? 58 : 11}px` }}>
			<div className="controls-row">

				{getMemberMenu(openMember)}

				<div className="controls-group">
					{/*
				<div className="control">
					<button
						className='control-button not-now'
						type="button"
						title="Grid"
						aria-label="Grid"
						aria-pressed="false"
						onClick={() => dispatch(enableGrid({}))}
					>
						5-Notifications
					</button>
				</div>

				*/}

					<div className="control">
						<button
							className={`control-button button-features ${isModalSupportEnabled ? 'selected' : ''}`}
							type="button"
							// title="Title"
							// aria-label="Title"
							aria-pressed="false"
							onClick={() => dispatch(toggleSupport('feedback', 'canvas'))}
						>
							{/* <span className="span-logo" aria-hidden="true">Feedback</span> */}
							<span className="button-text" aria-hidden="true">
								{t('t.ctrl_top_right.feedback')}
							</span>
						</button>
					</div>

					{/* <div className="control-divider right"></div>

					<Tooltip.Root ignoreNonKeyboardFocus delayDuration={300} disableHoverableContent>
						<Tooltip.Trigger asChild>

							<div className="control">
								<button
									disabled
									// className={`control-button button-comments ${isModalDiagramShareEnabled ? 'selected' : ''}`}
									className={`control-button button-comments disabled`}
									type="button"
									aria-pressed="false"
								// onClick={() => dispatch(toggleModalDiagramShare('canvas', diagramId))}
								>
									<svg className='icont-comment-top' width="25px" height="25px" viewBox="0 0 24 24">
										<g>
											<path
												d="M20,20h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h4 c0.6,0,1,0.4,1,1s-0.4,1-1,1H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v12C24,18.2,22.2,20,20,20z"></path>
										</g>
										<g>
											<path
												d="M12,24c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4 l-4,4C12.5,23.9,12.3,24,12,24z"></path>
										</g>
										<g>
											<path d="M18,7H6C5.4,7,5,6.6,5,6s0.4-1,1-1h12c0.6,0,1,0.4,1,1S18.6,7,18,7z"></path>
										</g>
										<g>
											<path d="M13,11H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h7c0.6,0,1,0.4,1,1S13.6,11,13,11z"></path>
										</g>
										<g>
											<path d="M16,15H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S16.6,15,16,15z"></path>
										</g>
									</svg>
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls wo-shortcut"
								side="bottom"
								align="center"
								sideOffset={12}
							>
								<span>Notifications</span>
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}


					<div className="control-divider left"></div>

					{allMembers.length > 0 && (
						<div className="control">

							<div className="members-stack">
								{allMembers.map((member) => {
									const user = member.user;
									if (!user) return null;
									const initial = (user.name || '?')[0].toUpperCase();
									return (
										<Tooltip.Root key={user.id} ignoreNonKeyboardFocus delayDuration={200} disableHoverableContent>
											<Tooltip.Trigger asChild>
												<button
													className={`member-avatar ${user.image ? '' : 'noavatar'} ${openMember?.user.id === user.id ? 'open' : ''}`}
													type="button"
													aria-pressed="false"
													onClick={(e) => handleAvatarClick(user, e)}
												>
													{user.image
														? <img src={getAvatarUrl(user.image)} width="24" height="24" referrerPolicy="no-referrer" />
														: <span>{initial}</span>
													}
												</button>
											</Tooltip.Trigger>
											<Tooltip.Portal>
												<Tooltip.Content
													className="tooltip-content tooltip-controls wo-shortcut"
													side="bottom"
													align="center"
													sideOffset={15}
												>
													<span>{user.id === currentUser.id ? `${user.name} (you)` : user.name}</span>
												</Tooltip.Content>
											</Tooltip.Portal>
										</Tooltip.Root>
									);
								})}
							</div></div>
					)}

					{allMembers.length > 0 && <div className="control-divider"></div>}

					{/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={300} disableHoverableContent>
						<Tooltip.Trigger asChild>
							<div className="control">
								<button
									disabled
									ref={profileBtnRef}
									className={`control-button button-profile`}
									type="button"
									aria-pressed="false"
								// onClick={() => {
								// }}
								>
									<span className="button-profile-text">E</span>
								</button>
							</div>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className="tooltip-content tooltip-controls"
								side="bottom"
								align="center"
								sideOffset={10}
							>
								<span>Profile</span>
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root> */}

					{/* <div className="control">
						<button
							ref={profileBtnRef}
							className={`control-button button-profile ${isBtnProfileEnabled && 'selected'}`}
							type="button"
							aria-pressed="false"
							onClick={() => dispatch(toggleBtnProfile())}
						>
							{currentUser.image
								? <img className="button-profile-image" src={currentUser.image} width="42px" height="42px" referrerPolicy="no-referrer" />
								: <span className="button-profile-text">{(currentUser?.name || currentUser?.email || '')[0].toUpperCase()}</span>
							}
						</button>
					</div> */}

					{/* <div className="control-divider"></div> */}

					<div className="control">
						<button
							className={`control-button button-share ${isModalDiagramShareEnabled ? 'selected' : ''}`}
							type="button"
							aria-pressed="false"
							onClick={() => dispatch(toggleModalDiagramShare('canvas', diagramId))}
						>
							{/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
							stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
							<path
								d="M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"></path>
						</svg> */}
							<span className="button-text" aria-hidden="true">{t('b.share')}</span>
						</button>
					</div>

				</div>

			</div>
		</div>
	);
};

export default ControlsTopRight;






















